/* Kiomia - la soglia da cui in poi possono comparire gli elementi fissi
   (pillola d'acquisto e bottone WhatsApp).

   In cima alla pagina non deve esserci niente sopra il contenuto: si arriva,
   si guarda il prodotto, e solo dopo compaiono gli aiuti.

   Il punto e' la prima sezione che troviamo fra queste, nell'ordine:
   i problemi, il quiz, i tre passi. Cerchiamo per suffisso dell'identificativo
   della sezione, non per classe: cosi' se un domani cambi l'ordine delle
   sezioni la soglia segue quella che capita per prima, senza toccare niente.

   Se nessuna e' presente (le altre pagine del sito) chi usa questa funzione
   decide da solo cosa fare. */
window.kmSoglia = (function(){
  var CANDIDATE = ['riconosci', 'quiz', 'passi', 'scienza'];

  function sezione(){
    for (var i = 0; i < CANDIDATE.length; i++){
      var el = document.querySelector('[id$="__' + CANDIDATE[i] + '"]');
      if (el) return el;
    }
    var g = document.querySelector('.km-ps__g');
    return g ? (g.closest('.shopify-section') || g) : null;
  }

  return {
    esiste: function(){ return !!sezione(); },
    superata: function(){
      var s = sezione();
      if (!s) return null;
      return s.getBoundingClientRect().top <= window.innerHeight;
    }
  };
})();
